import { render, staticRenderFns } from "./editSti04Dialog.vue?vue&type=template&id=6ddc0c7a&scoped=true"
import script from "./editSti04Dialog.vue?vue&type=script&lang=js"
export * from "./editSti04Dialog.vue?vue&type=script&lang=js"
import style0 from "./editSti04Dialog.vue?vue&type=style&index=0&id=6ddc0c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc0c7a",
  null
  
)

export default component.exports